export enum Receipt {
  Name = 'Document',
  MerchantCopy = 'MerchantCopy',
  CardHolderCopy = 'CardHolderCopy',
}
